import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { TextButton, TextWithIcon } from '../CustomElements'
import { Box, MainHeading, SpanStyled, SubHeadingStyled, TextStyled, } from '../Elements'
import { ContactEmail, ContactInstagram, ContactLinkedin, ContactPhone, ContactTiktok, ContactX, Instagram, LinkedIn, QrScan, SnapChat, Tiktok, Twitter } from '../AllImages'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
// import Footer from '../../footer/Footer'
import styled from 'styled-components'
const SocialLinks = () => {
	const WhatsApp = () => {
        const phoneNumber = '+966555625502';
        const message = 'Hello, this is Hisas';
        const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };
	const Map = ""
	const { t } = useTranslation();
	const socialIcon = [
			
		{
			img: <Twitter />,
			link: 'https://x.com/',
		},
		{
			img: <Tiktok />,
			link: 'https://www.tiktok.com/',
		},
		{
			img: <LinkedIn />,
			link: 'https://www.linkedin.com/',
		},
		{
			img: <Instagram />,
			link: 'https://www.instagram.com/',
		},
		
		
	]
	return (
		<>
			<SocialWrapper className='floatingSocial'>

                {/* <Box className='Social-links'> */}
                    {
                        socialIcon.map((list, key) => (
                            <a href={list.link} target="_blank" key={key} className='contact-links'>
                                {list.img}
                            </a>
                        ))
                    }
                {/* </Box> */}
										
			</SocialWrapper>
		</>
	)
}


const SocialWrapper = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 40px;
    margin: auto;
    display: flex;
    gap: 20px;
    z-index: 100;
    height: 236px;
    flex-wrap: wrap;
    width: 44px;
    cursor: pointer;
    a{
        border-radius: 50%;
        box-shadow: 0px 0 20px -5px rgba(0, 0, 0, 0.4);
        -webkit-box-shadow: 0px 0 20px -5px rgba(0, 0, 0, 0.4);
        -moz-box-shadow: 0px 0 20px -5px rgba(0, 0, 0, 0.4);
    }
    body.rtl &{
        left: auto;
        right: 40px;
        svg{
            -webkit-transform: scaleX(1) !important;
            -moz-transform: scaleX(1) !important;
            -o-transform: scaleX(1) !important;
            transform: scaleX(1) !important;
        }
    }
    @media (max-width: 991px) {
        left: 20px;
        body.rtl &{
            left: auto;
            right: 20px;
            
        }
    }
`

export default SocialLinks